/* tslint:disable */
/* eslint-disable */
/**
 * Sellsen API
 * Ürün Tarama ve SP-API Entegrasyonu
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the BuyerEmailImportResponse interface.
 */
export function instanceOfBuyerEmailImportResponse(value) {
    return true;
}
export function BuyerEmailImportResponseFromJSON(json) {
    return BuyerEmailImportResponseFromJSONTyped(json, false);
}
export function BuyerEmailImportResponseFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'received': json['received'] == null ? undefined : json['received'],
        'updated': json['updated'] == null ? undefined : json['updated'],
        'unchanged': json['unchanged'] == null ? undefined : json['unchanged'],
        'notFound': json['notFound'] == null ? undefined : json['notFound'],
        'invalid': json['invalid'] == null ? undefined : json['invalid'],
        'patched': json['patched'] == null ? undefined : json['patched'],
        'patchFailed': json['patchFailed'] == null ? undefined : json['patchFailed'],
    };
}
export function BuyerEmailImportResponseToJSON(json) {
    return BuyerEmailImportResponseToJSONTyped(json, false);
}
export function BuyerEmailImportResponseToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'received': value['received'],
        'updated': value['updated'],
        'unchanged': value['unchanged'],
        'notFound': value['notFound'],
        'invalid': value['invalid'],
        'patched': value['patched'],
        'patchFailed': value['patchFailed'],
    };
}
